import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { Device } from '@capacitor/device';
import { AuthService } from 'src/app/core/services/auth.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { EventService } from 'src/app/core/services/event.service';
import QRCode from 'qrcode';
import { AnalyticsService } from '../../core/services/analytics.service';
import { inviteLinkFor } from '../../core/utils/invite-link';

@Component({
    selector: 'app-qr-invite',
    templateUrl: "./qr-invite.component.html",
    styleUrls: ['./qr-invite.component.css']
})
export class QrInviteComponent {

    isAddContactPopupOpen: boolean = false;
    qrImage!: any;
    inviteLink!: any;
    link!: string;
    platform: any;
    panelOpenState = false;
    contactForm!: FormGroup;
    contacts: any[] = []; // Store contacts
    temp_contacts: any[] = [];
    event_id: any;
    user_id: any;

    isLoading: boolean = false;
    // Variable to track if editing
    editIndex: number | null = null;
    savedContacts: any;
    viewerLink: any;
    viewer_qrImage: any;
    // Define the columns to be displayed in the table
    displayedColumns: string[] = ['name', 'phone_number', 'email_address', 'actions'];
    event_name: string | null;
    filteredContacts: any[] = [];
    showAddContactForm = false;
    searchQuery: any;
    // web QR Code & Deep Links
    web_qrImage: any; // Replace with actual QR Code URL
    webLink: any;

    viewer_web_qrImage: any;
    viewerWebLink: any;
    role: string = 'Collaborator';

    constructor(private router: Router,
        private route: ActivatedRoute, private clipboard: Clipboard
        , private authService: AuthService, private eventService: EventService, private fb: FormBuilder, private http: HttpClient, private analytics: AnalyticsService) {
        this.contactForm = this.fb.group({
            name: ['', Validators.required],
            phone_number: ['', [Validators.pattern('^\\+?[1-9]\\d{1,14}$')]], // Simple phone number validation
            email_address: ['', [Validators.email]]
        }, {
            validators: phoneOrEmailValidator()  // Apply the custom validator
        });
        this.event_id = localStorage.getItem('e');
        this.user_id = localStorage.getItem('u');
        this.qrImage = localStorage.getItem('qrImage');
        this.event_name = localStorage.getItem('name');
        this.viewer_qrImage = localStorage.getItem('viewer_qrImage');
        this.viewerLink = inviteLinkFor(localStorage.getItem('eventId'));
    }

    ngOnInit() {
        this.isLoading = true;
        const currentUrl = window.location.origin;
        // console.log('Current URL:', currentUrl); //__CONSOLE_LOG__
        //  this.url = currentUrl+"/splash/"+this.hex;
        // Retrieve parameters from the URL
        this.route.queryParams.subscribe(params => {
            // this.qrImage = params['qrImage'];
            let inviteCode = params['inviteCode'];
            this.inviteLink = inviteLinkFor(inviteCode);
            this.webLink = currentUrl + "/splash/" + inviteCode;
            // this.webLink = "https://events.picaggo.com/splash/"+inviteCode;
            this.web_qrImage = localStorage.getItem('web_qrImage');// Replace with actual QR Code URL

            this.viewerWebLink = currentUrl + "/splash/" + localStorage.getItem('eventId');
            this.viewer_web_qrImage = localStorage.getItem('web_viewer_qrImage');
            this.isLoading = false;
        });

        (this.eventService.getUserContacts(this.event_id)).subscribe({
            next: (res: any) => {
                // console.log({ res }); //__CONSOLE_LOG__
                this.savedContacts = res.result.contacts;
                this.filteredContacts = this.savedContacts;
                this.contacts = res.result.eventContacts;
                this.temp_contacts = [...this.contacts];
            }
        })
    }


    openAddContactPopup() {
        if (this.searchQuery) {
            this.contactForm.patchValue({
                name: this.searchQuery // Replace with API response value
            });
        }
        this.isAddContactPopupOpen = true;
    }


    closeAddContactPopup() {
        this.editIndex = null;
        this.contactForm.reset();
        this.contacts = this.temp_contacts;
        this.isAddContactPopupOpen = false;
    }

    searchContacts(event: Event): void {
        const inputElement = event.target as HTMLInputElement;
        const searchValue = inputElement.value ? inputElement.value.toLowerCase() : '';

        this.filteredContacts = this.savedContacts.filter((contact: { name: string; phone_number: string | string[]; email_address: string; }) =>
            contact.name.toLowerCase().includes(searchValue) ||
            contact.phone_number?.includes(searchValue) ||
            contact.email_address?.toLowerCase().includes(searchValue)
        );
    }

    // Function to delete a contact from event
    async onDeleteContact(index: number, id: any): Promise<void> {
        this.isLoading = true;
        (await this.eventService.deleteContact(this.event_id, this.user_id, id)).subscribe({
            next: (res: any) => {
                this.isLoading = false;
                // console.log({ res }); //__CONSOLE_LOG__
                this.contacts.splice(index, 1);  // Remove the contact from the array
                this.temp_contacts = this.contacts;
            },
            error: (err: any) => {
                this.isLoading = false;

                // console.error(err); //__CONSOLE_LOG__
            }
        })

    }

    // Function to download QR Code image
    downloadImage(imageSrc: string, filename: string) {
        const link = document.createElement('a');
        link.href = imageSrc;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    // Function to copy text to clipboard
    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text).then(() => {
            alert('Link copied to clipboard!');
        }).catch(err => {
            // console.error('Error copying link: ', err); //__CONSOLE_LOG__
        });
    }

    //   // Copy Web Collaborator Link
    //   copyLink() {
    //     this.copyToClipboard(this.inviteLink);
    //   }

    // Copy Web Viewer Link
    copyViewerWebLink() {
        this.analytics.capture('invite_sent', { surface: 'qr_invite', format: 'link', method: 'copy', link_type: 'web_viewer', event_id: this.event_id });
        this.copyToClipboard(this.viewerWebLink);
    }

    copyWebLink() {
        this.analytics.capture('invite_sent', { surface: 'qr_invite', format: 'link', method: 'copy', link_type: 'web_collaborator', event_id: this.event_id });
        this.copyToClipboard(this.webLink);
    }

    // Copy App Collaborator Link
    copyAppLink() {
        this.analytics.capture('invite_sent', { surface: 'qr_invite', format: 'link', method: 'copy', link_type: 'app_collaborator', event_id: this.event_id });
        this.copyToClipboard(this.inviteLink);
    }

    // Copy App Viewer Link
    copyViewerAppLink() {
        this.analytics.capture('invite_sent', { surface: 'qr_invite', format: 'link', method: 'copy', link_type: 'app_viewer', event_id: this.event_id });
        this.copyToClipboard(this.viewerLink);
    }

    // Function to delete a contact
    async onDelete(index: number, id: any): Promise<void> {
        this.isLoading = true;

        (await this.eventService.deleteContact('null', this.user_id, id)).subscribe({
            next: (res: any) => {
                this.isLoading = false;

                // console.log({ res }); //__CONSOLE_LOG__
                this.savedContacts.splice(index, 1);  // Remove the contact from the array
            },
            error: (err: any) => {
                this.isLoading = false;

                // console.error(err); //__CONSOLE_LOG__
            }
        })

    }

    async shareAppLink() {
        this.analytics.capture('invite_sent', { surface: 'qr_invite', format: 'link', method: 'share', link_type: 'app_collaborator', event_id: this.event_id });
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_app_collab_qr.jpg';
        let qrImage: string = localStorage.getItem('qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }
        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const file = new File([blob], fileName.replace(/\s+/g, '-'), { type: blob.type });
        
              if (navigator.share) {
                navigator.share({
                  title: 'Event QR Code',
                  text: 'Scan to access the invite',
                  files: [file]
                }).catch(err => console.error('Share failed:', err));
              } else {
                // Fallback if share is not supported
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = fileName;
                link.click();
              }

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to share image:', error); //__CONSOLE_LOG__
        }
    
    }

    async shareAppViewerLink() {
        this.analytics.capture('invite_sent', { surface: 'qr_invite', format: 'link', method: 'share', link_type: 'app_viewer', event_id: this.event_id });
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_app_viewer_qr.jpg';
        let qrImage: string = localStorage.getItem('viewer_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }
        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const file = new File([blob], fileName.replace(/\s+/g, '-'), { type: blob.type });
        
              if (navigator.share) {
                navigator.share({
                  title: 'Event QR Code',
                  text: 'Scan to access the invite',
                  files: [file]
                }).catch(err => console.error('Share failed:', err));
              } else {
                // Fallback if share is not supported
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download =fileName;
                link.click();
              }

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to share image:', error); //__CONSOLE_LOG__
        }
    
    }

    async shareWebLink() {
        this.analytics.capture('invite_sent', { surface: 'qr_invite', format: 'link', method: 'share', link_type: 'web_collaborator', event_id: this.event_id });
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_web_collab_qr.jpg';
        let qrImage: string = localStorage.getItem('web_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }
        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const file = new File([blob], fileName.replace(/\s+/g, '-'), { type: blob.type });
        
              if (navigator.share) {
                navigator.share({
                  title: 'Event QR Code',
                  text: 'Scan to access the invite',
                  files: [file]
                }).catch(err => console.error('Share failed:', err));
              } else {
                // Fallback if share is not supported
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = fileName;
                link.click();
              }

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to share image:', error); //__CONSOLE_LOG__
        }
    
    }


    async shareWebViewerLink() {
        this.analytics.capture('invite_sent', { surface: 'qr_invite', format: 'link', method: 'share', link_type: 'web_viewer', event_id: this.event_id });
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_web_viewer_qr.jpg';
        let qrImage: string = localStorage.getItem('web_viewer_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }
        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const file = new File([blob], fileName.replace(/\s+/g, '-'), { type: blob.type });
        
              if (navigator.share) {
                navigator.share({
                  title: 'Event QR Code',
                  text: 'Scan to access the invite',
                  files: [file]
                }).catch(err => console.error('Share failed:', err));
              } else {
                // Fallback if share is not supported
                const link = document.createElement('a');
                link.href = URL.createObjectURL(file);
                link.download = fileName;
                link.click();
              }

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to share image:', error); //__CONSOLE_LOG__
        }
    
    }

    // Function to handle editing a contact
    onEditContact(index: number): void {
        this.isAddContactPopupOpen = true;
        this.editIndex = index;  // Save index of the contact being edited
        const contact = this.contacts[index];
        // console.log(contact); //__CONSOLE_LOG__

        // Fill the form with the selected contact's data
        this.contactForm.setValue({
            name: contact.name,
            phone_number: contact.phone_number,
            email_address: contact.email_address
        });
        this.contacts.splice(index, 1);
    }


    async saveContact(selectedContact: any) {
        this.isAddContactPopupOpen = false;
        this.isLoading = true;
        let contact_Id = 'null';
        // console.log(this.contactForm.value); //__CONSOLE_LOG__
        // console.log(selectedContact); //__CONSOLE_LOG__
        if (selectedContact != null) {
            contact_Id = selectedContact?.id;
        }

        if (this.contactForm.valid) {
            const contact = this.contactForm.value;

            // Simulate saving contact via API
            (await this.eventService.saveContact(this.event_id, this.user_id, contact.name, contact.phone_number, contact.email_address, contact_Id)).subscribe({
                next: (res: any) => {
                    // console.log({ res }); //__CONSOLE_LOG__

                    if (res) {
                        // Add contact to the local list
                        this.contacts = res.result.contacts;
                        // this.contacts.push(contact);

                        // Clear the form
                        this.contactForm.reset();

                        this.panelOpenState = false;
                    }

                    (this.eventService.getUserContacts(this.event_id)).subscribe({
                        next: (res: any) => {
                            // console.log({ res }); //__CONSOLE_LOG__
                            this.isLoading = false;
                            this.savedContacts = res.result.contacts;
                            this.filteredContacts = this.savedContacts;
                            this.contacts = res.result.eventContacts;
                        }

                    })
                },
                error: (err: any) => {
                    // console.error(err); //__CONSOLE_LOG__
                    this.isLoading = false;
                    this.isAddContactPopupOpen = false;
                }
            })
        }
    }


    onSelectPreviousContact(index: number): void {
        //  this.isLoading = true;

        const selectedContact = this.savedContacts[index];

        // Check if the contact already exists in the current list
        const contactExists = this.contacts.some(contact =>
            contact.name === selectedContact.name &&
            contact.phone_number === selectedContact.phone_number &&
            contact.email_address === selectedContact.email_address
        );

        // Add the selected contact to the current list if it doesn't exist already
        if (!contactExists) {
            this.contacts.push(selectedContact);
            this.contactForm.setValue({
                name: selectedContact.name,
                phone_number: selectedContact.phone_number,
                email_address: selectedContact.email_address
            });
            this.saveContact(selectedContact);
        } else {
            alert('This contact is already in the list.');
            this.isLoading = false;
            //  this.contacts.splice(index, 1);
        }
    }

    downloadAppImage(): void {
        const link = document.createElement('a');
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_app_collab_qr.jpg';
        let qrImage: string = localStorage.getItem('qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }

        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            link.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to download image:', error); //__CONSOLE_LOG__
        }
    }

    downloadViewerAppImage(): void {
        const link = document.createElement('a');
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_app_viewer_qr.jpg';
        let qrImage: string = localStorage.getItem('viewer_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }

        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            link.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to download image:', error); //__CONSOLE_LOG__
        }


    }

    downloadWebImage(): void {
        const link = document.createElement('a');
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_web_collab_qr.jpg';
        let qrImage: string = localStorage.getItem('web_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }

        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            link.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to download image:', error); //__CONSOLE_LOG__
        }
    }

    downloadWebViewerImage(): void {
        const link = document.createElement('a');
        const fileType = 'image/jpeg'; // Replace with the appropriate type, e.g., 'image/png'
        const fileName = this.event_name + '_web_viewer_qr.jpg';
        let qrImage: string = localStorage.getItem('web_viewer_qrImage') ?? '';
        if (!qrImage) {
            // console.error('Base64 image string is empty'); //__CONSOLE_LOG__
            return;
        }

        try {
            // Sanitize Base64 string and remove the prefix if present
            const sanitizedBase64 = qrImage.replace(/^data:image\/[a-z]+;base64,/, '').trim();

            // Convert Base64 to Blob
            const blob = this.base64ToBlob(sanitizedBase64, fileType);

            // Create a link element to trigger download
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            link.click();

            // Clean up the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            // console.error('Failed to download image:', error); //__CONSOLE_LOG__
        }


    }
    // Helper function to convert Base64 to Blob
    private base64ToBlob(base64: string, contentType: string): Blob {
        const byteCharacters = atob(base64);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    }

    setRole(role: string) {
        this.role = role;
    }

    copyLink() {
        this.analytics.capture('invite_sent', { surface: 'qr_invite', format: 'link', method: 'copy', link_type: 'app_collaborator', event_id: this.event_id });
        this.clipboard.copy(this.inviteLink);
        alert('Link Copied!');
    }

    goBack(){
        this.router.navigate(['/event-detail/true']);
    }

    async gotoHome() {
        this.isLoading = true;
        localStorage.removeItem('eventId');
        localStorage.removeItem('qrImage');
        localStorage.removeItem('name');
        localStorage.removeItem('viewer_qrImage');
        localStorage.removeItem('isHost');
        localStorage.removeItem('isScheduled');
        //localStorage.removeItem('u');
        localStorage.removeItem('e');
        localStorage.removeItem('eventData');
        localStorage.removeItem('inviteData');
        this.router.navigate(['/home']);

    }

    async saveAndgotoHome() {
        this.isLoading = true;

        (await this.eventService.inviteUsers(this.event_id)).subscribe({
            next: (res: any) => {
                // console.log({ res }); //__CONSOLE_LOG__
                localStorage.removeItem('eventId');
                localStorage.removeItem('qrImage');
                localStorage.removeItem('name');
                localStorage.removeItem('viewer_qrImage');
                localStorage.removeItem('isHost');
                localStorage.removeItem('isScheduled');
                //localStorage.removeItem('u');
                localStorage.removeItem('e');
                localStorage.removeItem('eventData');
                localStorage.removeItem('inviteData');
                localStorage.removeItem('formData');
                localStorage.removeItem('coverImage');
                this.router.navigate(['/home']);
            },
            error: (err: any) => {
                this.isLoading = false;

                // console.error(err); //__CONSOLE_LOG__
            }
        })

    }

    logout() {
        this.authService
            .signOut()
            .then((res) => {
                this.router.navigateByUrl(
                    "/auth/login"
                );
            })
            .catch((err) => {
                // console.error(err); //__CONSOLE_LOG__
            });
    }

    async downloadApp() {
        const info = await Device.getInfo();

        if (this.platform.IOS && info.model === 'iPhone' && info.platform === 'web') {
            window.location.href = 'https://apps.apple.com/in/app/picaggo/id1527686260';
        }

        if (this.platform.ANDROID && info.platform === 'web') {
            window.location.href = 'https://play.google.com/store/apps/details?id=application.share.photo.picaggo';
        }


        if (!this.platform.ANDROID && !this.platform.IOS && info.platform === 'web') {
            window.location.href = 'https://picaggo.com';
        }
    }

}


// Custom validator to check that either phone or email is present
export function phoneOrEmailValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
        const phone = group.get('phone_number')?.value;
        const email = group.get('email_address')?.value;

        // Check if both are empty
        if (!phone && !email) {
            return { phoneOrEmailRequired: true };  // Error if both are empty
        }
        return null;  // Valid if at least one is present
    };
}